import axios from "axios";
import {getBaseUrl} from "./ApiUrls";


export default class AuthService {
    static async login(username, password) {
        const response = await axios.post(getBaseUrl() + "/auth/token/login/", {username: username, password: password});
        return response.data;
    }
}